var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_43194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.461426C7.17764 0.461426 0 7.63906 0 16.4614C0 25.2831 7.17764 32.4614 16 32.4614C24.8217 32.4614 32 25.2831 32 16.4614C32 7.63906 24.823 0.461426 16 0.461426ZM19.9791 17.0247H17.376V26.3027H13.5187C13.5187 26.3027 13.5187 21.2332 13.5187 17.0247H11.6852V13.7456H13.5187V11.6246C13.5187 10.1055 14.2406 7.73187 17.4114 7.73187L20.2697 7.74282V10.9259C20.2697 10.9259 18.5328 10.9259 18.1951 10.9259C17.8574 10.9259 17.3773 11.0948 17.3773 11.8192V13.7462H20.3161L19.9791 17.0247Z",
    fill: "white",
    fillOpacity: 0.68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_43194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.461426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook-1.c6832b2a44e74a1120b1cda1d3a2f85b.svg";
export { ForwardRef as ReactComponent };